import { render, staticRenderFns } from "./page-footer-win3.vue?vue&type=template&id=27c9b6c3&scoped=true"
import script from "./page-footer-win3.vue?vue&type=script&lang=js"
export * from "./page-footer-win3.vue?vue&type=script&lang=js"
import style0 from "./page-footer-win3.vue?vue&type=style&index=0&id=27c9b6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9b6c3",
  null
  
)

export default component.exports